//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class AddDynamicDataSetModel extends ModelBase {
      static readonly $typeName = 'AddDynamicDataSetModel';
      public name: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/models/AddDynamicDataSetModel.ts